<template>
  <div>
    <v-row class="ma-0 mt-35">
      <v-col class="pa-0">
        <v-data-table
          :headers="$getHeaderType1(headerTxt, headers)"
          :items="documents"
          hide-default-footer
          :items-per-page="9999"
          class="new__type__table"
          :mobile-breakpoint="MobileBreakPoint"
        >
          <template v-slot:item="{item, index}">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>{{$t('myapplication.myapplication_details.fields.annual_fee')}}</td>
              <td>
                {{ $vuetify.rtl ? item.fee_name_ar : item.fee_name_en }}
              </td>
              <td>{{ item.due_date }}</td>
              <td>
                <v-chip dark color="#98bbbf" @click="$emit('annualfee', item)">{{$t('common.button.pay')}}</v-chip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'

export default {
  props: {
    seq:  String
  },
  components:{
  },
  data () {
		return {
      MobileBreakPoint:0,
      headerTxt : {
        prefix : 'myapplication.myapplication_details.fields.',
        txt : [ '#', 'type','followup_actions','due_date','' ]
      },
      headers : [
        { text: '#', align: 'center', width:'65', sortable: false, },
        { text: 'Type', align: 'center', sortable: false ,width:'120'},
        { text: 'Follow-up Actions', align: 'center', sortable: false },
        { text: 'Due Date', align: 'center', width: '120', sortable: false },
        { text: '',  align: 'center', sortable: false, width: '120' },
      ],
      documents : []
    }
  },
  mounted(){
    this.fnGetAnnualfees()
  },
  methods : {

    fnGetAnnualfees(){
      this.documents = []
      if (this.seq) {
        requestApi({
          url: '/applications/' + this.seq + '/upcoming/annualfees',
          method: 'GET',
          callback: (res) => {
            if (res.res_code === '200') {
              this.documents = res.data.list
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnGetAnnualfees()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },

    getColor (status_type_code) {
      if (status_type_code === '8941') return '#99bc44'
      else if (status_type_code === '8942') return '#00af50'
      else if (status_type_code === '8943') return '#00af50'
      else return '#1f94a6'
    }
  }
}
</script>